module.exports = __webpack_public_path__ + "static/media/alert.3a949a39.png";